import React from "react";

import { LayoutPortalContext } from "../../components/Layout";

/**
 * Hook to access the LayoutPortalContext value.
 *
 * @returns The LayoutPortalContext value.
 * @throws Will throw an error if used outside of a LayoutPortalContext provider.
 * @example
 * const layoutPortal = useLayoutPortal();
 */
function useLayoutPortal() {
  const layoutPortal = React.useContext(LayoutPortalContext);

  if (layoutPortal === undefined) {
    throw new Error(
      "useLayoutPortal must be used within a LayoutPortalContext provider."
    );
  }

  return layoutPortal;
}

export default useLayoutPortal;
